import { GridAction } from '@eforall/dashboard';
import { SurveysBySpecialistRow } from '../surveys-by-specialist-view.part';

export function getActions() {

	const actions: GridAction<SurveysBySpecialistRow>[] = [];

	return actions;
}